import { inject, injectable } from "@launchtray/tsyringe-async";
import { Bindable, NotifyProperty, nameof } from "../../../../../../../shared/bindable-data";
import { IMarketplaceBuildingModel } from "./IMarketplaceBuildingModel";
import { INetworkClient } from "../../../../../../networking/INetworkClient";
import { MarketplaceBuildingItem } from "./MarketplaceBuildingItem";
import { PrepareMintResult } from "./PrepareMintResult";

@injectable()
export class MarketplaceBuildingModel extends Bindable implements IMarketplaceBuildingModel {
    public readonly currentBuilding: NotifyProperty<MarketplaceBuildingItem>;
    private readonly networkClient: INetworkClient;

    public constructor(
        @inject("INetworkClient") networkClient: INetworkClient
    ) {
        super();
        this.networkClient = networkClient;
        this.currentBuilding = new NotifyProperty(this, nameof("currentBuilding"), null);
    }

    public async loadBuildingInfo(mpBuildingId: string): Promise<boolean> {
        const buildingItemDto = await this.networkClient.getMarketplaceBuildingFullInfo(mpBuildingId);
        if (buildingItemDto == null) {
            return false;
        }
        const buildingItem = new MarketplaceBuildingItem(buildingItemDto);
        this.currentBuilding.setValue(buildingItem);
        return true;
    }

    public async prepareMint(mpBuildingId: string, couponBenefitIds?: Array<string>): Promise<PrepareMintResult> {
        const result = await this.networkClient.mpPrepareMint(mpBuildingId, couponBenefitIds);
        return new PrepareMintResult(result);
    }
}
